import { call, put, takeLatest } from "redux-saga/effects";
import { setIsLoading } from "../App/action";
import { setProfile } from "../Client/action";
import {
	addComment,
	addNewNft,
	addNewPost,
	deleteComment,
	deletePost,
	getPost,
	getPostProfile,
	getPostQuery,
	getS3UploadUrl,
} from "../../Domain/api";
import { uploadFile } from "../../Utils/awsHelper";
import { setVisitedProfile } from "../../Pages/Home/action";
import { setPostData, setPostError } from "./action";
import {
	ADD_COMMENT,
	ADD_NFT,
	ADD_POST,
	DELETE_COMMENT,
	DELETE_POST,
	GET_POSTS,
} from "./constants";

export function* doAddPost({ post, cbSuccess }) {
	try {
		yield put(setIsLoading(true));
		if (post.files.length > 0) {
			const { urls } = yield call(getS3UploadUrl, {
				totalImage: post.files.length,
			});
			const upload = uploadFile(urls, post.files);

			post.files = upload;
		}
		yield call(addNewPost, post);
		yield put(setIsLoading(false));
		cbSuccess && cbSuccess();
	} catch (error) {
		yield put(setPostError(error.message));
		yield put(setIsLoading(false));
	}
}

export function* doGetPosts({ page, username, query, isVisiting }) {
	try {
		yield put(setIsLoading(true));
		let result;
		if (username) {
			result = yield call(getPostProfile, { username, page });
			isVisiting
				? yield put(setVisitedProfile(result.user))
				: yield put(setProfile(result.user.profile));
		} else if (query) {
			result = yield call(getPostQuery, { page, query });
		} else {
			result = yield call(getPost, { page });
		}
		yield put(setPostData(result.posts));
		yield put(setIsLoading(false));
	} catch (error) {
		yield put(setIsLoading(false));
	}
}

export function* doUploadNft({ data, cbSuccess, cbFailed }) {
	try {
		yield put(setIsLoading(true));
		const result = yield call(addNewNft, data);
		const { tokenId, receipt, address } = result.nft;
		yield put(setIsLoading(false));
		cbSuccess && cbSuccess(tokenId, address, receipt);
	} catch (error) {
		yield put(setIsLoading(false));
		cbFailed && cbFailed(error);
	}
}

export function* doDeletePost({ postId, cbSuccess }) {
	try {
		yield call(deletePost, { postId });
		cbSuccess && cbSuccess();
	} catch (error) {
		window.location.reload();
	}
}

export function* doAddComment({ parentId, isFromPost, comment, cbSuccess }) {
	try {
		yield call(addComment, { parentId, isFromPost, comment });
		cbSuccess && cbSuccess();
	} catch (error) {
		window.location.reload();
	}
}

export function* doDeleteComment({ commentId, cbSuccess }) {
	try {
		yield call(deleteComment, { commentId });
		cbSuccess && cbSuccess();
	} catch (error) {
		window.location.reload();
	}
}

export default function* addPost() {
	yield takeLatest(ADD_POST, doAddPost);
	yield takeLatest(GET_POSTS, doGetPosts);
	yield takeLatest(ADD_NFT, doUploadNft);
	yield takeLatest(DELETE_POST, doDeletePost);
	yield takeLatest(ADD_COMMENT, doAddComment);
	yield takeLatest(DELETE_COMMENT, doDeleteComment);
}
